import { useMutation } from '@tanstack/react-query';
import { getTicketOutcomes } from '../requests/ticketOutcomeReport.request';
import {
  TicketOutcomeReportRequest,
  TicketOutcomeReportResponse
} from '../types/ticketOutcomeReport.types';
import toast from 'react-hot-toast';
import { AxiosError } from 'axios';

export const useTicketOutcomesQuery = () => {
  return useMutation<TicketOutcomeReportResponse, AxiosError, TicketOutcomeReportRequest>({
    mutationKey: ['ticket-outcomes'],
    mutationFn: getTicketOutcomes,
    onError: (error) => {
      toast.error(error.message || 'Failed to fetch ticket outcomes');
    }
  });
};
